import React, { useState } from 'react';
import './Contacts.css';
import {
    Card,
    Row,
    Col,
    Typography,
    Button,
    Space,
    Tag,
    Tooltip,
    notification
} from 'antd';
import {
    PhoneOutlined,
    EnvironmentOutlined,
    MessageOutlined,
    CopyOutlined,
    CheckOutlined,
    CarOutlined,
    GiftOutlined
} from '@ant-design/icons';

import { SHOP_INFO, ADVANTAGES } from '../../constants/shopData';

const { Title, Text, Paragraph } = Typography;

export const Contacts = () => {
    const [copiedPhone, setCopiedPhone] = useState(false);

    const handleCopyPhone = () => {
        navigator.clipboard.writeText(SHOP_INFO.phoneClean);
        setCopiedPhone(true);

        notification.success({
            message: 'Номер скопирован',
            description: 'Номер телефона скопирован в буфер обмена',
            duration: 2,
        });

        setTimeout(() => setCopiedPhone(false), 2000);
    };

    const handleOpenMap = (addressText?: string) => {
        const address = encodeURIComponent(addressText || `${SHOP_INFO.addresses.bulgakovo}, ${SHOP_INFO.addresses.ufa}`);
        window.open(`https://yandex.ru/maps/?text=${address}`, '_blank');
    };

    return (
        <div>
            <Card
                title={
                    <Space orientation="vertical" size="small" style={{ width: '100%' }}>
                        <Title level={3} className="contacts__title" >{SHOP_INFO.name}</Title>
                        <Text type="secondary">Дарим красоту и эмоции каждый день</Text>
                    </Space>
                }
                variant="borderless"
                style={{
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    borderRadius: 12
                }}
            >
                {/* Особенности магазина */}
                <Space wrap size={[8, 8]} style={{ marginBottom: 24 }}>
                    {ADVANTAGES.map((adv) => (
                        <Tag
                            key={adv.id}
                            icon={adv.id === 'delivery' ? <CarOutlined /> : <GiftOutlined />}
                            color="geekblue"
                            style={{ padding: '4px 12px', borderRadius: 20 }}
                        >
                            {adv.title}
                        </Tag>
                    ))}
                    <Text type="secondary" className="contacts__text">* Бесплатная доставка доступна по с. Булгаково и г. Уфа в будни и непраздничные дни</Text>
                </Space>

                <Row gutter={[24, 24]}>
                    {/* Адрес магазина */}
                    <Col xs={24} md={12}>
                        <Card
                            size="small"
                            title={
                                <Space>
                                    <EnvironmentOutlined />
                                    <Text strong>Адреса магазинов</Text>
                                </Space>
                            }
                            extra={
                                <Button
                                    type="link"
                                    size="small"
                                    onClick={() => handleOpenMap()}
                                    icon={<EnvironmentOutlined />}
                                >
                                    Карта
                                </Button>
                            }
                            style={{ height: '100%' }}
                        >
                            <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
                                <div style={{ background: '#fafafa', padding: 12, borderRadius: 8, border: '1px solid #f0f0f0' }}>
                                    <Paragraph style={{ margin: '0 0 6px 0' }}>
                                        <Text strong>{SHOP_INFO.addresses.bulgakovo}</Text>
                                    </Paragraph>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, fontSize: 13 }}>
                                        <Text type="secondary">Ежедневно:</Text>
                                        <Text strong>{SHOP_INFO.workingHours.bulgakovo}</Text>
                                    </div>
                                    <Button
                                        type="primary"
                                        size="small"
                                        block
                                        onClick={() => handleOpenMap(SHOP_INFO.addresses.bulgakovo)}
                                        icon={<EnvironmentOutlined />}
                                    >
                                        Точка на карте
                                    </Button>
                                </div>

                                <div style={{ background: '#fafafa', padding: 12, borderRadius: 8, border: '1px solid #f0f0f0' }}>
                                    <Paragraph style={{ margin: '0 0 6px 0' }}>
                                        <Text strong>{SHOP_INFO.addresses.ufa}</Text>
                                    </Paragraph>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, fontSize: 13 }}>
                                        <Text type="secondary">Ежедневно:</Text>
                                        <Text strong>{SHOP_INFO.workingHours.ufa}</Text>
                                    </div>
                                    <Button
                                        type="primary"
                                        size="small"
                                        block
                                        onClick={() => handleOpenMap(SHOP_INFO.addresses.ufa)}
                                        icon={<EnvironmentOutlined />}
                                    >
                                        Точка на карте
                                    </Button>
                                </div>
                            </Space>
                        </Card>
                    </Col>

                    {/* Email и соцсети */}
                    <Col xs={24} md={12}>
                        <Card
                            size="small"
                            title={
                                <Space>
                                    <MessageOutlined />
                                    <Text strong>Связь с нами</Text>
                                </Space>
                            }
                            style={{ height: '100%' }}
                        >
                            <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
                                <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
                                    <span itemProp="telephone">{SHOP_INFO.phone}</span>
                                </Title>

                                <Space wrap style={{ width: '100%' }}>
                                    <Tooltip title={copiedPhone ? "Скопировано!" : "Копировать номер"}>
                                        <Button
                                            icon={copiedPhone ? <CheckOutlined /> : <CopyOutlined />}
                                            onClick={handleCopyPhone}
                                        >
                                            {copiedPhone ? "Скопировано" : "Копировать"}
                                        </Button>
                                    </Tooltip>

                                    <Button
                                        type="primary"
                                        href={`tel:${SHOP_INFO.phoneClean}`}
                                        icon={<PhoneOutlined />}
                                    >
                                        Позвонить
                                    </Button>
                                </Space>
                            </Space>
                            <br/>
                            <Space orientation="vertical" size="middle" style={{ width: '100%', marginTop: '10px' }}>
                                {/* Социальные сети */}
                                <Space wrap style={{ width: '100%', justifyContent: 'flex-start' }}>
                                    <Tooltip title="Telegram">
                                        <Button
                                            type="default"
                                            shape="circle"
                                            icon={<MessageOutlined style={{ color: '#0088cc' }} />}
                                            size="large"
                                            href={SHOP_INFO.socialMedia.telegram}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        />
                                    </Tooltip>

                                    <Tooltip title="WhatsApp">
                                        <Button
                                            type="default"
                                            shape="circle"
                                            icon={<PhoneOutlined style={{ color: '#25D366' }} />}
                                            size="large"
                                            href={SHOP_INFO.socialMedia.whatsapp}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        />
                                    </Tooltip>

                                    {SHOP_INFO.socialMedia.vk && (
                                        <Tooltip title="ВКонтакте">
                                            <Button
                                                type="default"
                                                shape="circle"
                                                icon={<MessageOutlined style={{ color: '#0077FF' }} />}
                                                size="large"
                                                href={SHOP_INFO.socialMedia.vk}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            />
                                        </Tooltip>
                                    )}

                                    {SHOP_INFO.socialMedia.max && (
                                        <Tooltip title="MAX">
                                            <Button
                                                type="default"
                                                shape="circle"
                                                icon={<MessageOutlined style={{ color: '#8b00ff' }} />}
                                                size="large"
                                                href={SHOP_INFO.socialMedia.max}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            />
                                        </Tooltip>
                                    )}
                                </Space>
                            </Space>
                        </Card>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};